export default __webpack_public_path__ + "static/media/ro_flag.4f40cbd2.svg";